import React from "react";

export const FieldRoot = ({ label, hint, error, required, children, className = "" }) => (
  <div className={`fld ${className}`}>
    {label && (
      <label className="fld__label">
        {label}
        {required && <span className="fld__required" aria-hidden="true">*</span>}
      </label>
    )}
    {children}
    {error ? (
      <span className="fld__error">{error}</span>
    ) : hint ? (
      <span className="fld__hint">{hint}</span>
    ) : null}
  </div>
);

export const Field = React.forwardRef(({
  label, hint, error, required,
  icon, type = "text", as = "input",
  className = "", controlClassName = "",
  disabled,
  ...inputProps
}, ref) => {
  const ctrlCls = [
    "fld__control",
    as === "textarea" && "fld__control--textarea",
    error && "fld__control--error",
    disabled && "fld__control--disabled",
    controlClassName,
  ].filter(Boolean).join(" ");

  const InputTag = as;
  const inputExtra = as === "input" ? { type } : {};

  return (
    <FieldRoot label={label} hint={hint} error={error} required={required} className={className}>
      <div className={ctrlCls}>
        {icon && <span className="fld__icon">{icon}</span>}
        <InputTag ref={ref} disabled={disabled} {...inputExtra} {...inputProps} />
      </div>
    </FieldRoot>
  );
});

Field.displayName = "Field";

export const SelectField = React.forwardRef(({
  label, hint, error, required, icon, className = "", controlClassName = "",
  children, disabled, ...selectProps
}, ref) => {
  const ctrlCls = [
    "fld__control",
    error && "fld__control--error",
    disabled && "fld__control--disabled",
    controlClassName,
  ].filter(Boolean).join(" ");

  return (
    <FieldRoot label={label} hint={hint} error={error} required={required} className={className}>
      <div className={ctrlCls}>
        {icon && <span className="fld__icon">{icon}</span>}
        <select ref={ref} disabled={disabled} {...selectProps}>{children}</select>
      </div>
    </FieldRoot>
  );
});
SelectField.displayName = "SelectField";

export default Field;
